const dayjs = require('dayjs')

export const isLoading = ( state ) => { 
    state.loadingGlobal = !state.loadingGlobal
    
}
export const closeLoading = (state) => {
    state.loadingGlobal = false

}
export const iniciarCasoAutWcx = ( state ) => { 
    state.reclamoAutomatico = !state.reclamoAutomatico
    
}

export const loadDatos = ( state, datos ) => { 
    state.datos = datos
    
}

export const dataVtex = ( state, datos ) => { 
    state.dataVtex = datos
    
}

export const selectedProduct = ( state, products ) => { 
    state.selectedProduct = products
    
}

export const plazoEntrega = ( state, dias ) => { 
    state.plazoEntrega = dias
    
}

export const enFarmaciaHasta = ( state, fecha ) => { 
    state.enFarmaciaHasta = fecha

    let fecha1 = fecha.split('/')[2]+'-'+fecha.split('/')[1]+'-'+fecha.split('/')[0]

    let currentDate = dayjs(new Date()).format('YYYY-MM-DD')

    state.mostrarChat = dayjs(fecha1).isAfter(currentDate) 
    // state.dias30 = dayjs(fecha1).isAfter(currentDate) 
    
}
export const setArrepentido = ( state, status ) => {
    state.arrepentido = status
}
export const ocultarChat = ( state, status ) => {
    state.mostrarChat = status
}
export const fechaEntrega = ( state, fecha ) => { 
    state.fechaEntrega = fecha
    
}

export const enTiempo = (state, fecha) => {
    state.enTiempo = fecha

}
export const estadoCaso = ( state, estado ) => { 
    state.estadoCaso = estado
    
}

export const cancelarPedido = ( state ) => { 
    state.pedidoCancelado = true
    
}

export const setNumeroCaso = ( state, numero ) => { 
    state.numeroCaso = numero
    
}

export const addMessage  = ( state, message ) => { 
    state.messages.push(message)
    state.datos.sentMessages++
}


export const reclamo = ( state, reclamo ) => { 
    console.log('const reclamo', reclamo);
    state.datos.datos_reclamo = reclamo.length ? [...reclamo] : reclamo
    state.datos.wc_tipo       = reclamo.length ? reclamo[0].wc_tipo : reclamo.wc_tipo
    state.datos.reclamo       = reclamo.length ? reclamo[0].id    : reclamo.id
    state.datos.id_wc         = reclamo.length ? reclamo[0].id_wc : reclamo.id_wc
    state.datos.sentMessages  = 0
    
}
